var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'react-emotion';
import { ReactComponent as Check } from '../svg/Check.svg';
const CheckInput = styled('input') `
  /* hide browser default checkbox */
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;
const CheckBox = styled('span') `
  height: 22px;
  width: 22px;
  background-color: transparent;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
`;
const CheckMark = styled(Check) `
  display: none;
  width: 1em;
  height: 1em;
  use {
    fill: white;
  }
`;
const Label = styled('label') `
  display: flex;
  position: relative;
  height: 22px;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  :hover input ~ span {
    background-color: #ccc;
  }
  input:focus ~ span {
    border-color: #2f80ed;
  }
  input:checked ~ span {
    background-color: black;
    svg {
      display: block;
    }
  }
`;
const Checkbox = (_a) => {
    var { label } = _a, props = __rest(_a, ["label"]);
    return (React.createElement(Label, { className: props.className },
        React.createElement(CheckInput, Object.assign({ type: "checkbox" }, props)),
        React.createElement(CheckBox, null,
            React.createElement(CheckMark, null)),
        label));
};
Checkbox.Label = Label;
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map